

export const amazonRegion =    { 
        "NA":"NA", // *United States
        "EU":"EU", // *Europe
        "FE":"FE" // *Far East
}
